const DOWNLOAD = {
    onReady() {
        this.page = document.querySelector('.download');
        if (this.page === null) return;
        DOWNLOAD.buildPages();
    },
    buildPages() {
        let mmToPx        = parseFloat(DOWNLOAD.page.clientHeight / 297); // One Millimeter in Pixel
        let contentHeight = parseFloat((297 - 30) * mmToPx);
        var totalHeight   = 0;
        var currentHeight = 0;
        let questions     = document.querySelectorAll('.download__question');
        questions.forEach(question => {
            totalHeight += question.clientHeight;
        });
        let pageCount = Math.ceil(totalHeight / contentHeight);
        var jj = 0;
        for (var ii = 1; ii <= pageCount; ii++) {
            let template = document.getElementById('template-page').content.cloneNode(true);
            for (kk = jj; kk < questions.length; kk++) {
                currentHeight += questions[jj].clientHeight;
                if (currentHeight <= contentHeight) {
                    template.querySelector('.download').insertAdjacentHTML('beforeend', `<div class='download__question'>${questions[jj].innerHTML}</div>`);
                    jj++;       
                }
            }
            console.log(jj);
            console.log(currentHeight);
            currentHeight = 0;
            this.page.parentNode.insertBefore(template, this.page);
        }
        this.page.remove();
    }
}